import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { useEffect, useState, type ReactNode } from 'react'
import { ApiError } from '../lib/api/errors'
import { onSessionChange } from '../lib/api/client'

function createQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      queries: {
        staleTime: 30_000,
        gcTime: 5 * 60_000,
        refetchOnWindowFocus: false,
        retry: (failureCount, error) => {
          // 4xx não se resolve tentando de novo.
          if (error instanceof ApiError && error.statusCode < 500) return false
          return failureCount < 2
        },
      },
      mutations: { retry: false },
    },
  })
}

export function AppProviders({ children }: { children: ReactNode }): ReactNode {
  const [queryClient, setQueryClient] = useState(createQueryClient)

  // Cache recriado a cada troca de sessão: dado do usuário anterior nunca
  // sobrevive ao login seguinte. Ver docs/specs/16-security.md.
  useEffect(() => {
    return onSessionChange(() => {
      setQueryClient((current) => {
        current.clear()
        return createQueryClient()
      })
    })
  }, [])

  return <QueryClientProvider client={queryClient}>{children}</QueryClientProvider>
}
